import * as React from 'react';
import {
    GridColumnMenuSort,
    GridColumnMenuFilter,
    GridColumnMenuCheckboxFilter,
    GridColumnMenuProps,
    GridColumnMenuCheckboxFilterProps,
    GridColumnMenuItemGroup,
    GridColumnMenuItem,
    GridColumnMenuItemContent
} from '@progress/kendo-react-grid';
import { GridFilterOperators } from '@progress/kendo-react-grid/dist/npm/interfaces/GridFilterOperators';
import { GridColumnMenuColumnProps } from '@progress/kendo-react-grid/dist/npm/interfaces/GridColumnMenuColumnProps';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { ComponentType } from 'react';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDown, LookUpDropDown } from '..';
import { FilterDescriptor } from '@progress/kendo-react-dropdowns/dist/npm/common/filterDescriptor';
import SystemSwitch from '../inputs/SystemSwitch';
import { IDataSourceType } from '../types/IDynamicList';
import { GridColumnMenuFilterBaseProps } from '@progress/kendo-react-grid/dist/npm/interfaces/GridColumnMenuFilterBaseProps';
import { GridColumnMenuSortBaseProps } from '@progress/kendo-react-grid/dist/npm/interfaces/GridColumnMenuSortBaseProps';

export class CheckBoxMenu extends React.Component<GridColumnMenuCheckboxFilterProps> {
    gcms: GridColumnMenuColumnProps = { field: "", filter: "text" };
    constructor(props: any) {
        super(props)
    }

    render() {

        return (
            <div>
                <GridColumnMenuCheckboxFilter {...this.props} expanded={true} data={[""]} searchBox={() => null} />
            </div>
        );
    }
}


export interface SystemGridColumnFilterMenuProps extends GridColumnMenuProps {
    type: "DATE" | "TEXT" | "NUMBER" | "BOOLEAN" | "LOOKUP" | "DROPDOWN" | "RANGE" | "TABLE",
    lookupName?: string,
    dataSource?: string,
    dataSourceType?: IDataSourceType,
    idField?: string,
    displayField?: string
    min?: number,
    max?: number
}

export class SystemGridColumnFilterMenu extends React.Component<SystemGridColumnFilterMenuProps, any, any> {
    state = {
        value1: null,
        value2: null,
        operator: "",
        join: "" // AND or OR
    }

    componentDidMount = () => {
        if (this.props.filter && this.props.filter.filters && this.props.filter.filters.length > 0 && this.props.onFilterChange) {
            var i = this.props.filter.filters.findIndex((item: any) => item.field == this.props.column.field)
            if (i != -1) {
                this.setState({ value1: this.props.filter.filters[i].value })
            }
        }
    }

    onReset = (event: any) => {
        if (this.props.filter && this.props.onFilterChange) {
            var i = this.props.filter.filters.findIndex((item: any) => item.field == this.props.column.field)
            if (i != -1) {
                this.props.filter.filters.splice(i, 1);
                this.props.onFilterChange(this.props.filter, event);
            }
        }
        if (this.props.onCloseMenu) {
            this.props.onCloseMenu();
        }
    }

    onSubmit = (event: any) => {

        if (this.props.filter) {
            if ((this.state.value1 === undefined || this.state.value1 === null || this.state.value1 === '') && (this.state.value1 != false)) {

                this.onReset(event);
                return;
            }
            var filter = (this.props.filter.filters || []).find(item => item.field === this.props.column.field)
            if (filter) {
                filter.value = this.state.value1
            } else {
                this.props.filter.filters.push({ field: this.props.column.field, operator: "eq", value: this.state.value1 })
            }
            this.props.onFilterChange && this.props.onFilterChange(this.props.filter, event);
        }
        else {
            this.props.onFilterChange && this.props.onFilterChange({ logic: "and", filters: [{ field: this.props.column.field, operator: "eq", value: this.state.value1 }] }, event);
        }


        if (this.props.onCloseMenu) {
            this.props.onCloseMenu();
        }
    }

    onChange = (event?: any, name?: any, value?: any, text?: any) => {
        if (this.props.type == "BOOLEAN")
            this.setState({ [name]: value ? true : false })
        else
            this.setState({ [name]: value })
    }

    SetupControls = () => {
        switch (this.props.type) {
            case "DATE": break;

            case "TEXT": break;

            case "NUMBER": break;

            case "BOOLEAN":
                return <SystemSwitch name="value1" hideLabel={true} value={this.state.value1} onChange={this.onChange} />

            case "LOOKUP":
                return <LookUpDropDown id="value1" name="value1" hideLabel={true} value={this.state.value1} onChange={this.onChange} lookupName={this.props.lookupName as string} />

            case "TABLE":
                return <DropDown name="value1" dataSourceType={this.props.dataSourceType} dataSource={this.props.dataSource} idField={this.props.idField} displayField={this.props.displayField} hideLabel={true} value={this.state.value1} onChange={this.onChange} />

            case "DROPDOWN": break;

            case "RANGE":
                return (
                    <div>
                        Min:
                        <span style={{ margin: '0 16px 0 2px' }}>
                            <NumericTextBox name="value1" width="70px" value={this.state.value1 && this.props.min} onChange={this.onChange} min={this.props.min} max={this.state.value2 || undefined} />
                        </span>
                        Max:
                        <span style={{ margin: '0 2px 0 4px' }}>
                            <NumericTextBox name="value2" width="70px" value={this.state.value2 && this.props.max} onChange={this.onChange} min={this.state.value1 || undefined} max={this.props.max} />
                        </span>
                    </div>
                )
        }
    }

    render() {
        return (
            <div className={'text-center'}>
                <div className={'k-column-list'}>
                    {this.SetupControls()}
                </div>
                <div className={'action_padding'}>
                    <button type={'reset'} onClick={this.onReset} className={'k-button k-button-icon k-clear-button-visible cstmBtn'}>Clear</button>
                    <button onClick={this.onSubmit} className={'k-button k-primary cstmBtn'}>Filter</button>
                </div>
            </div>
        );
    }
}

export class TextNumericColumnMenuFilter extends React.Component<GridColumnMenuProps> {


    render() {

        return (
            <div>
                <GridColumnMenuFilter {...this.props} expanded={true} hideSecondFilter={this.props.column.filter == "date" ? false : true} filterOperators={
                    {
                        'text': [
                            { text: 'grid.filterContainsOperator', operator: 'contains' },
                            { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
                            { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
                            { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
                            { text: 'grid.filterEqOperator', operator: 'eq' },
                            { text: 'grid.filterNotEqOperator', operator: 'neq' },
                        ],
                        'numeric': [
                            { text: 'grid.filterEqOperator', operator: 'eq' },
                            { text: 'grid.filterNotEqOperator', operator: 'neq' },
                            { text: 'grid.filterGteOperator', operator: 'gte' },
                            { text: 'grid.filterGtOperator', operator: 'gt' },
                            { text: 'grid.filterLteOperator', operator: 'lte' },
                            { text: 'grid.filterLtOperator', operator: 'lt' },
                            { text: 'grid.filterIsNullOperator', operator: 'isnull' },
                            { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
                        ],
                        'date': [
                            { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
                            { text: 'grid.filterEqOperator', operator: 'eq' },
                            { text: 'grid.filterNotEqOperator', operator: 'neq' },
                            { text: 'grid.filterAfterOperator', operator: 'gt' },
                            { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
                            { text: 'grid.filterBeforeOperator', operator: 'lt' },
                        ],
                        'boolean': [
                            { text: 'grid.filterEqOperator', operator: 'eq' }
                        ]

                    }} />
            </div>
        );
    }
}

export class NumberColumnMenuFilter extends React.Component<GridColumnMenuProps> {


    render() {
        return (
            <div>
                <GridColumnMenuFilter {...this.props} expanded={true} hideSecondFilter={true} filterOperators={
                    {
                        'number': [
                            { text: 'grid.filterContainsOperator', operator: 'contains' },
                            { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
                            { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
                            { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
                            { text: 'grid.filterEqOperator', operator: 'eq' },
                            { text: 'grid.filterNotEqOperator', operator: 'neq' },
                        ]
                    }} />
            </div>
        );
    }
}

export default class RangeFilterCell extends React.Component {
    minTextBox: any;
    maxTextBox: any;

    inRange = (current: number, { min, max }) => (min === null || current >= min) && (max === null || current <= max);

    onChange = (event: any) => {
        this.props.onChange({
            value: { min: this.minTextBox.value, max: this.maxTextBox.value },
            operator: this.inRange,
            syntheticEvent: event.syntheticEvent
        });
    }

    onClearButtonClick = (event: any) => {
        event.preventDefault();
        this.props.onChange({
            value: null,
            operator: '',
            syntheticEvent: event
        });
    }

    render() {
        const value = this.props.value || null;

        return;
    }
}


export const LookUpFilterMenu = (props: SystemGridColumnFilterMenuProps) => <SystemGridColumnFilterMenu {...props} type="LOOKUP" />
export const BooleanFilterMenu = (props: SystemGridColumnFilterMenuProps) => <SystemGridColumnFilterMenu {...props} type="BOOLEAN" />
export const TableFilterMenu = (props: SystemGridColumnFilterMenuProps) => <SystemGridColumnFilterMenu {...props} type="TABLE" />


export const ClinicalNoteAreaFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceClinicalNoteArea" dataSourceType="URL" displayField="Area" idField="Area" />
export const ClinicalNoteCategoryFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceClinicalNoteCategory" dataSourceType="URL" displayField="Category" idField="Category" />
export const ReferenceResourceFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceResource/List" dataSourceType="URL" displayField="Name" idField="Name" />
export const SecurityUserFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="SecurityUser/ListWithNames" dataSourceType="URL" displayField="PersonName" idField="UserId" />
export const ReferenceEncounterTypeFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceEncounterType/List" dataSourceType="URL" displayField="EncounterTypeName" idField="EncounterTypeName" />
export const ReferencePayerServiceTypeFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferencePayerServiceType/List"
    dataSourceType="URL" displayField="PayerServiceTypeName" idField="PayerServiceTypeName" />
export const ReferencePayerTypeFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferencePayerType/List"
    dataSourceType="URL" displayField="Code" idField="Code" />
export const ReferencePayerTypeNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferencePayerType/List"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const PayerFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="Payer/List"
    dataSourceType="URL" displayField="PayerName" idField="PayerName" />
export const ReferenceCountryFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceCountry/list"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const ReferenceStateFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceState/list"
    dataSourceType="URL" displayField="StateName" idField="StateName" />
export const ReferenceCityFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceCity/list"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const ReferenceCompanyNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceCompany/List"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const InsuranceCompanyFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceInsurer/list"
    dataSourceType="URL" displayField="InsurerName" idField="InsurerName" />
export const TpaNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceTpa/list"
    dataSourceType="URL" displayField="Tpaname" idField="Tpaname" />
export const NetworkNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceNetwork/List"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const ReferenceOrderNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceOrder/List"
    dataSourceType="URL" displayField="OrderName" idField="OrderName" />
export const ReferenceResourceTypeNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceResourceType/List"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const ReferenceBrokerNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="ReferenceBroker/list"
    dataSourceType="URL" displayField="BrokerName" idField="BrokerName" />
export const ServicesNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="Encounter/List"
    dataSourceType="URL" displayField="Services" idField="Services" />
export const EncounterStatusNameFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="Encounter/List"
    dataSourceType="URL" displayField="EncounterStatus" idField="EncounterStatus" />
export const PrincipleIDTypeLookUpFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="/ReferenceCountryIdType/ByCountryIdList?CountryId=3"
    dataSourceType="URL" displayField="Name" idField="Name" />
export const CommunicationChannelFilterMenu = (props: any) => <TableFilterMenu  {...props} dataSource="CommunicationChannel/list"
    dataSourceType="URL" displayField="Name" idField="Name" />


///Encounter/EncounterHistoryList

export const PatientNameLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-PatientName" />
export const YesNoLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-YesNo" />
export const SQLLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-SQL" />
export const GenderLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Gender" />
export const TitleLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Title" />
export const DrivingLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Driving" />
export const MaritalStatusLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-MaritalStatus" />
export const NationalityLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Nationality" />
export const ResidencyStatusLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-ResidencyStatus" />
export const IDTypeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-IDType" />
export const PlaceOfBirthLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-PlaceOfBirth" />
export const EthnicGroupLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-EthnicGroup" />
export const PreferredLanguageLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-PreferredLanguage" />
export const EmploymentLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Employment" />
export const PrimaryCarePhysicianLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-PrimaryCarePhysician" />
export const StatusLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Status" />
export const CountryLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Country" />
export const AddressTypeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-AddressType" />
export const RelationShipLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-RelationShip" />
export const ContactMethodLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-ContactMethod" />
export const PaymentCategoryLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-PaymentCategory" />
export const InsurerOrganizationLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-InsurerOrganization" />
export const TPALookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-TPA" />
export const InsurerProgramLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-InsurerProgram" />
export const ContactCountryCodeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-ContactCountryCode" />
export const SideLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-Side" />
//export const PrincipleIDTypeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-PrincipleIDType" />
export const ResourceTypeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-ResourceType" />
export const CompanyNameLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-CompanyName" />
export const EncounterCategoryLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-EncounterCategory" />
export const EncounterStatusLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-EncounterStatus" />
export const DiaryFrequencyLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-DiaryFrequency" />
export const DiaryStatusLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-DiaryStatus" />
export const DiaryActionsLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-DiaryActions" />
export const SurgicalStatusFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-StatusSurgicalImmunization" />
export const FollowUpStatusFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-FollowupStatus" />
export const EncounterSearchStatusFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-EncounterStatus" />
export const EncounterLabTestCategoryFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-TestCategory" />
export const EncounterLabRequestStatusFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-LabStatus" />
export const EncounterLabRequestTypeFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-LabRequestType" />


//Lookup-DiaryStatus
//Encounter Type

export const CallTypeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-CallType" />
export const CommunicationCategoryLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-CommunicationCategory" />
export const OrderTypeLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-OrderType" />
export const PatientSmokeStatusFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-SmokeStatus" />
export const ClientServiceIconFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-ClientServiceTypeIcon" />
export const EncounterCommunicationCategoryFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-OrderCommunicationCategory" />
export const FamilyRelationLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-FamilyRelations" />
export const FamilySeverityLookUpFilterMenu = (props) => <LookUpFilterMenu {...props} lookupName="Lookup-FamilySeverity" />